export const isPanelVisible = (panelConfig: server.dto.IPanelConfig) => panelConfig.displayPanel;